function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 8C0 7.44772 0.447715 7 1 7H47C47.5523 7 48 7.44772 48 8C48 8.55228 47.5523 9 47 9H0.999999C0.447714 9 0 8.55228 0 8Z",
  fill: "#EAEEF4"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 18.3333,
  y: 14.3333,
  width: 36,
  height: 2,
  rx: 1,
  fill: "#EAEEF4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M118 45.875C118 45.3918 118.392 45 118.875 45H165.125C165.608 45 166 45.3918 166 45.875C166 46.3582 165.608 46.75 165.125 46.75H118.875C118.392 46.75 118 46.3582 118 45.875Z",
  fill: "#EAEEF4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M113 51.125C113 50.6418 113.392 50.25 113.875 50.25H142.125C142.608 50.25 143 50.6418 143 51.125C143 51.6082 142.608 52 142.125 52H113.875C113.392 52 113 51.6082 113 51.125Z",
  fill: "#EAEEF4"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 79,
  cy: 87.5,
  rx: 60,
  ry: 9.5,
  fill: "#F5F8FA"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 17,
  r: 17,
  fill: "#EAEEF4"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 103.5,
  cy: 35.5,
  r: 11.5,
  fill: "#EAEEF4"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 61,
  y: 7,
  width: 36,
  height: 67,
  rx: 4,
  fill: "url(#paint0_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M79 32.3333V33.4166M85.5 45.3333H87.6666M79 45.3333V49.6666M79 37.7499V40.9999M79 40.9999H79.0108M79 40.9999H83.3441M83.3333 49.6666H87.6666M70.3333 40.9999H74.6666M87.6666 40.9999H87.6775M71.4166 36.6666H73.5833C74.1816 36.6666 74.6666 36.1816 74.6666 35.5833V33.4166C74.6666 32.8183 74.1816 32.3333 73.5833 32.3333H71.4166C70.8183 32.3333 70.3333 32.8183 70.3333 33.4166V35.5833C70.3333 36.1816 70.8183 36.6666 71.4166 36.6666ZM84.4166 36.6666H86.5833C87.1816 36.6666 87.6666 36.1816 87.6666 35.5833V33.4166C87.6666 32.8183 87.1816 32.3333 86.5833 32.3333H84.4166C83.8183 32.3333 83.3333 32.8183 83.3333 33.4166V35.5833C83.3333 36.1816 83.8183 36.6666 84.4166 36.6666ZM71.4166 49.6666H73.5833C74.1816 49.6666 74.6666 49.1816 74.6666 48.5833V46.4166C74.6666 45.8183 74.1816 45.3333 73.5833 45.3333H71.4166C70.8183 45.3333 70.3333 45.8183 70.3333 46.4166V48.5833C70.3333 49.1816 70.8183 49.6666 71.4166 49.6666Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 96.7065,
  y1: 73.005,
  x2: 51.5538,
  y2: 65.7443,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007CFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00BAFF"
})));

function SvgDeviceWithQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 97,
    viewBox: "0 0 166 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = React.forwardRef(SvgDeviceWithQrCode);
export default __webpack_public_path__ + "static/media/device-with-qr-code.b5074b96.svg";
export { ForwardRef as ReactComponent };